import React, { useState } from "react";

// Material UI Components
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";

// Components
import CallNotesHeader from "./CallNotesHeader";
import CallNotesBody from "./CallNotesBody";
import Paginate from "../../../../../Utilities/Paginate";

// This component will hold the latest leads data
const CallNotesTable = ({ callNotes, open }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const createData = (
    orderId,
    displayName,
    noteDate,
    callNoteContent,
    dispositionDescription
  ) => {
    return {
      orderId,
      displayName,
      noteDate,
      callNoteContent,
      dispositionDescription,
    };
  };
  const CallNotes = callNotes.map(
    ({
      orderId,
      displayName,
      noteDate,
      callNoteContent,
      dispositionDescription,
    }) =>
      createData(
        orderId,
        displayName,
        noteDate,
        callNoteContent,
        dispositionDescription
      )
  );
  return (
    <div className={`defaulted ${open ? "show-table" : "hide-table"}`}>
      <TableContainer>
        <Table className="table">
          <CallNotesHeader />
          <CallNotesBody 
            callNotes={CallNotes}
            page={page}
            rowsPerPage={rowsPerPage}
          />
        </Table>
      </TableContainer>
      {callNotes.length > rowsPerPage ? 
        <Paginate totalRowCount={callNotes.length} page={page} rowsPerPage={rowsPerPage} handleChange={handleChangePage} handleChangeRowsPerPage={handleChangeRowsPerPage} showCorePaginate={true} />
        : null
      }      
      <div className="bottom-footer"></div>
    </div>
  );
};

export default CallNotesTable;
